import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <FormattedMessage id="tags.popular" defaultMessage="POPULAR" />;
